// https://theme-ui.com/theme-spec

/* Misc Notes:
  1. heading refers to h1, h2, h3, etc. Not the header/footer
  10. This file is executed once Serverside, and once Clientside
*/

/////    Brand Specific Color Settings    /////

const lumePrimaryPalette = {

  primaries: {
    blue: '#00a3bf',
    purple: '#ad0da6',
    darkGrey: '#201F21',
    black: '#000'
  },
  new: {
    // Primary button colors
    primaryBlue: '#0077d7',
    primaryBlueHover: '#004a75',
    
    // Lume brand blue (alternative blue)
    lumeBlue: '#00a3bf',
    lumeBlueHover: '#008a9f',
    
    // Purple
    purple: '#ad0da6',
    purpleHover: '#8b0a85',
    
    // Coral/Pink
    coral: '#ff6f61',
    coralHover: '#e65c50',
    
    // Basic colors
    white: '#ffffff',
    black: '#000000',
    
    // Text colors
    textGrey: '#333333',
    
    // Teal (from backgrounds)
    teal: '#009f9d',
    tealHover: '#008080',
  },
  backgrounds: {
    blue: 'rgba(115, 209, 223, 0.8)',
    lightBlue: '#E5F7FA',
    darkBlue: '#2196f3',
    lightPurple: '#F2DDFC',
    teal: 'rgba(0, 159, 157, 0.5)',
    white: '#FFF',
  },
  secondaries: {
    evergreenBg2: '#9383CF',
    evergreenText2: '#5544B9', // footer.p - "Meet Flamingo", "Questions? We've got answers", etc
    secondarypurple: '#33077E',
    bodyMoistureBg1: '#0C413B',
    bodyMoistureText1: '#0C413B', // also Wax Info Tablist
  },
  old: {
    
  },

  fonts: {
    poppins: 'Poppins, Helvetica, Arial, sans-serif',
    menlo: 'Menlo, monospace',
  },

  referenceColors: {
    text: '#201F21',
    body: '#201F21',
    heading: '#000000',
    background: '#FFF', 
    primary: '#2B1453', // primaries.evergreenBg1,
    secondary: '#9383CF', // secondaries.evergreenBg2,
    muted: '#bfbfbf', // grays.gray40,
    navList: '#5544B9', // secondaries.evergreenText2
    headerCTA: '#2B1453', // primaries.evergreenBg1
    link: '#3ca6e0', 
  }

  
};


// Theme config exported for access in components, build loop, and builder configs
const lumeStyles = {
  brand: 'lume',
  referenceColors: lumePrimaryPalette.referenceColors,
  breakpoints: ['48em', '64em', '90em'],
  space: {
    none: '0',
    small: ['0.375em', '0.375em', '0.75em'], // Arrays set responsive values from smallest breakpoint to largest
    medium: ['0.5em', '0.5em', '1em'],
    large: ['0.75em', '0.75em', '1.5em'],
    xlarge: ['1.2em', '1.5em', '3em'],
    mega: ['4em', '4em', '8em'],
  },
  sizes: {
    container: ['100%', '43.25em', '61.25em', '76.25em'],
    viewHeight100: '100vh',
    viewWidth100: '100vw',
    navHeight: '100px',
    footerHeight: '270px',
  },
  fonts: {
    body: lumePrimaryPalette.fonts.poppins,
    heading: lumePrimaryPalette.fonts.poppins,
    monospace: lumePrimaryPalette.fonts.menlo,
    nav: lumePrimaryPalette.fonts.poppins,
  },
  
  fontSizes: [16, 20, 24, 28, 30, 32, 36, 40, 38, 48],
  fontWeights: {
    body: 300,
    heading: 500,
    bold: 700,
  },
  lineHeights: {
    body: 1.75,
    heading: 1.25,
    button: 1.5,
  },
  letterSpacings: {
    body: 0.5,
    heading: 0.9,
    caps: '0.125em',
    caption: '0.0625em',
  },
  // User exposed color options in the Builder UI are also drawn from this theme
  // Color must be defined here to be used in backgroundColors and other sub categories
  colors: { 
    text: '#201F21',
    body: '#201F21',
    heading: '#201F21',
    white: lumePrimaryPalette.primaries.white,
    primary: lumePrimaryPalette.primaries.evergreenText1,
    secondary: lumePrimaryPalette.secondaries.evergreenBg2,
    muted: lumePrimaryPalette.primaries.darkGrey,
    link: lumePrimaryPalette.secondaries.evergreenText2,

    // Backgrounds
    blue: lumePrimaryPalette.backgrounds.blue,
    lightBlue: lumePrimaryPalette.backgrounds.lightBlue,
    lightPurple: lumePrimaryPalette.new.purple,
    teal: lumePrimaryPalette.backgrounds.teal,

    purple: lumePrimaryPalette.primaries.purple,
    darkGrey: lumePrimaryPalette.primaries.darkGrey,


    // Legacy -- keeping for references
    blue_t: lumePrimaryPalette.primaries.blue,
    purple_t: lumePrimaryPalette.primaries.purple,
    darkGrey_t: lumePrimaryPalette.primaries.darkGrey,
    
    transparent: 'transparent',
  },
  // Used for component background colors
  backgroundColors: {
    blue: lumePrimaryPalette.backgrounds.brightBlue,
    lightBlue: lumePrimaryPalette.backgrounds.lightBlue,
    lightPurple: lumePrimaryPalette.backgrounds.lightPurple,
    teal: lumePrimaryPalette.backgrounds.teal,
    white: lumePrimaryPalette.backgrounds.white,
    transparent: 'transparent',
  },
  radii: {
    card: ['0.25em', '0.5em'],
    button: ['6px', '6px'],
  },
  shadows: {
    card: '0 0.125em 0.1875em 0 rgba(0,0,0,0.2)',
  },
  text: {
    body: {
      fontFamily: 'body',
      fontWeight: 'body',
      lineHeight: 'body',
      letterSpacing: 'body',
    },
    heading: {
      fontFamily: 'heading',
      fontWeight: 'heading',
      lineHeight: 'heading',
      letterSpacing: 'heading',
    },
  },
  // theme variants
  buttons: {
    primary: {
      bg: '#0077d7',
      borderRadius: '50px',
      color: '#fff',
      fontFamily: lumePrimaryPalette.fonts.poppins,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '1.5',
      letterSpacing: '0.8px',
      marginBottom: 'medium',
      padding: ['0.75em 1.5em', '0.75em 2em'],
      verticalAlign: 'middle',
      WebkitTransition: 'background-color 0.3s ease',
      transition: 'background-color 0.3s ease',
      whiteSpace: 'nowrap',
      border: 'none',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        bg: '#004a75',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: '0 0 0 3px rgba(0, 119, 215, 0.3)',
      },
      '& + a': {
        marginLeft: ['none', 'none', 'small'],
      },
    },
    secondary: {
      variant: 'buttons.primary',
      bg: '#ffffff',
      color: '#000000',
      fontFamily: lumePrimaryPalette.fonts.poppins,
      fontSize: '14px',
      fontWeight: '600',
      borderRadius: '50px',
      padding: ['0.75em 1.5em', '0.75em 2em'],
      border: '2px solid #000000',
      borderColor: '#000000',
      transition: 'background-color 0.3s ease, color 0.3s ease',
      position: 'relative',
      '&:after': {
        content: '""',
        display: 'inline-block',
        width: '7px',
        height: '12px',
        marginLeft: '0.5em',
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 7 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.18644 5.64473C6.36667 5.86567 6.35357 6.19171 6.14762 6.39766L1.64762 10.8977L1.60514 10.9365C1.3842 11.1167 1.05816 11.1036 0.852207 10.8977C0.646254 10.6917 0.633157 10.3657 0.813388 10.1447L0.852207 10.1023L4.9545 5.99996L0.852207 1.89766C0.632537 1.67799 0.632537 1.32192 0.852207 1.10225C1.07188 0.882582 1.42795 0.882582 1.64762 1.10225L6.14762 5.60225L6.18644 5.64473Z' fill='currentColor'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        verticalAlign: 'middle',
        transition: 'transform 0.3s ease, color 0.3s ease',
      },
      '&:hover': {
        bg: '#000000',
        color: '#ffffff',
        borderColor: '#000000',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
      '&:focus': {
        outline: 'none',
        boxShadow: '0 0 0 2px #000000',
      },
    },
    hollow: {
      variant: 'buttons.primary',
      bg: 'transparent',
      color: '#0077d7',
      border: '2px solid #0077d7',
      borderColor: '#0077d7',
      transition: 'background-color 0.3s ease, color 0.3s ease',
      '&:hover': {
        bg: '#0077d7',
        color: '#fff',
        borderColor: '#0077d7',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: '0 0 0 3px rgba(0, 119, 215, 0.3)',
      },
    },
    link: {
      variant: 'buttons.primary',
      paddingLeft: 0,
      paddingRight: 0,
      bg: 'transparent',
      color: 'heading',
      textDecoration: 'underline',
      '&:hover': {
        bg: 'transparent',
      },
    },
    bodyMoisture: {
      variant: 'buttons.primary',
      bg: 'bodyMoistureBg2',
      '&:hover': {
        bg: 'bodyMoistureBg14',
      },
    },
    pink: {
      variant: 'buttons.primary',
      bg: '#DE1B83',
      '&:hover': {
        bg: '#D1197B',
      },
    },
    orange: {
      variant: 'buttons.primary',
      bg: '#FE5000',
      '&:hover': {
        bg: '#E74C05',
      },
    },
  },
  // markdown styles
  styles: {
    root: {
      header: {
        fontSize: '11px',
      },
      variant: 'text.body',
      h1: {
        variant: 'text.heading',
        fontWeight: '600',
        fontSize: ['36px', '48px'],
        fontFamily: lumePrimaryPalette.fonts.poppins, 
        lineHeight: '1.2',
        letterSpacing: '0',
        textTransform: 'none',
        margin: '0 0 1rem 0',
        color: '#000000',
      },
      h2: {
        variant: 'text.heading',
        fontSize: ['28px', '36px'],
        fontFamily: lumePrimaryPalette.fonts.poppins, 
        fontWeight: '600',
        lineHeight: '1.3',
        letterSpacing: '0',
        margin: '0 0 0.75rem 0',
        color: '#000000',
      },
      h3: {
        variant: 'text.heading',
        fontSize: ['24px', '30px'],
        fontFamily: lumePrimaryPalette.fonts.poppins,
        fontWeight: '600',
        lineHeight: '1.4',
        letterSpacing: '0',
        margin: '0 0 0.5rem 0',
        color: '#000000',
      },
      h4: {
        variant: 'text.heading',
        fontSize: ['20px', '24px'],
        fontFamily: lumePrimaryPalette.fonts.poppins,
        fontWeight: '600',
        lineHeight: '1.5',
        letterSpacing: '0',
        margin: '0 0 0.5rem 0',
        color: '#000000',
      },
      h5: {
        variant: 'text.heading',
        fontSize: ['18px', '20px'],
        fontFamily: lumePrimaryPalette.fonts.poppins,
        fontWeight: '600',
        lineHeight: '1.6',
        letterSpacing: '0',
        margin: '0 0 0.5rem 0',
        color: '#000000',
      },
      h6: {
        variant: 'text.heading',
        fontSize: ['16px', '18px'],
        fontFamily: lumePrimaryPalette.fonts.poppins,
        fontWeight: '600',
        lineHeight: '1',
        letterSpacing: '0',
        textTransform: 'none',
        margin: '0 0 0.5rem 0',
        color: '#000000',
      },
      p: {
        lineHeight: '140%',
        fontSize: '16px',
        color: '#333333',
        // letterSpacing: '-0.15px',
        // margin: 0,
      },
      a: {
        color: 'link',
        textDecoration: 'none',
      },
      table: {
        borderCollapse: 'collapse',
        borderSpacing: 0,
      },
      tr: {
        fontSize: '1.1em',
      },
      th: {
        color: 'heading',
        padding: '0.4em',
        borderBottom: '2px solid rgba(0,0,0,0.2)',
        textTransform: 'uppercase',
        verticalAlign: 'middle',
      },
      td: {
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        padding: '0.4em',
        lineHeight: '1.8em',
        verticalAlign: 'middle',
        '& p': {
          fontSize: '80%',
          margin: '0.4em 0',
          lineHeight: '1.3',
        },
      },
    },
    textStyles: ['default', 'dropshadowWhite', 'dropshadowPurple', 'dropshadowTeal', 'quote'],
    textColors: ['default', 'blue', 'purple', 'darkGrey', 'white'],
    default: {
      h1: { 
        color: 'heading', 
      },
      h2: { 
        color: 'heading', 
      },
      h3: { 
        color: 'heading',
      },
      h4: { 
        color: 'heading',
      },
      h5: { 
        color: 'heading',
      },
      h6: { 
        color: 'heading'
      },
      p: {
        color: 'body' 
      }
    },
    dropshadowPurple: {
      h1: { 
        textShadow: '0.085106383em 0.085106383em 0 #ad0da6',
        WebkitTextStroke: '0.0394736842em #ad0da6',
      },
      h2: { 
        textShadow: '0.085106383em 0.085106383em 0 #ad0da6',
        WebkitTextStroke: '0.0394736842em #ad0da6',
      },
      h3: { 
        textShadow: '0.085106383em 0.085106383em 0 #ad0da6',
        WebkitTextStroke: '0.0394736842em #ad0da6',
      },
      h4: { 
        textShadow: '0.085106383em 0.085106383em 0 #ad0da6',
        WebkitTextStroke: '0.0394736842em #ad0da6',
      },
      h5: { 
        textShadow: '0.085106383em 0.085106383em 0 #ad0da6',
        WebkitTextStroke: '0.0394736842em #ad0da6',
      },
      h6: { 
        textShadow: '0.085106383em 0.085106383em 0 #ad0da6',
        WebkitTextStroke: '0.0394736842em #ad0da6',
      },
    },
    dropshadowWhite: {
      h1: { 
        textShadow: '0.085106383em 0.085106383em 0 #fff',
      },
      h2: { 
        textShadow: '0.085106383em 0.085106383em 0 #fff',
      },
      h3: { 
        textShadow: '0.085106383em 0.085106383em 0 #fff',
      },
      h4: { 
        textShadow: '0.085106383em 0.085106383em 0 #fff',
      },
      h5: { 
        textShadow: '0.085106383em 0.085106383em 0 #fff',
      },
      h6: { 
        textShadow: '0.085106383em 0.085106383em 0 #fff',
      },
    },
    dropshadowTeal: {
      h1: { 
        textShadow: '4px 4px 2px #009f9d',
      },
      h2: { 
        textShadow: '4px 4px 2px #009f9d',
      },
      h3: { 
        textShadow: '4px 4px 2px #009f9d',
      },
      h4: { 
        textShadow: '4px 4px 2px #009f9d',
      },
      h5: { 
        textShadow: '4px 4px 2px #009f9d',
      },
      h6: { 
        textShadow: '4px 4px 2px #009f9d',
      },
    },
    quote: {
      borderLeft: 'solid 2px #008AA2',
      paddingLeft: '20px',
      color: '#981b90',
      fontFamily: 'Poppins',
      lineHeight: '1.5',
      fontStyle: 'italic',
    }
  },
};

export default lumeStyles;